import React, { FC, useEffect } from 'react'

type Variant = 'smallcircle'

type Props = {
  variant?: Variant
  style?: React.CSSProperties
}

export const PageLayout: FC<Props> = ({ children, variant, style }) => {
  const isSmallCircle = variant === 'smallcircle'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className={isSmallCircle ? 'is-sm-circle' : ''} style={style}>
      <div className="pagecircle"></div>
      {children}
    </main>
  )
}
